module.exports = __webpack_public_path__ + "media/slider/Banner-5-9fcfd8bf.jpg";